import {
  FETCHING_CREATED_FORMS, FETCHING_CREATED_FORMS_FAILED, FETCHING_CREATED_FORMS_SUCCEEDED,
  FORM_MANAGE_VIEW, INVALIDATE_FORMS,
  FETCHING_FORM_FAILED, FETCHING_FORM_REQUEST, FETCHING_FORM_SUCCEEDED,

  CREATING_HUBSPOT_FORM_FAILED, CREATING_HUBSPOT_FORM_REQUEST, CREATING_HUBSPOT_FORM_SUCCEDDED,
  DELETING_HUBSPOT_FORM_REQUEST, DELETING_HUBSPOT_FORM_SUCCEEDED, DELETING_HUBSPOT_FORM_FAILED,
  UPDATING_HUBSPOT_FORM_REQUEST, UPDATING_HUBSPOT_FORM_SUCCEEDED, UPDATING_HUBSPOT_FORM_FAILED,

  CREATING_MARKETO_FORM_REQUEST, CREATING_MARKETO_FORM_SUCCEDDED, CREATING_MARKETO_FORM_FAILED,
  DELETING_MARKETO_FORM_REQUEST, DELETING_MARKETO_FORM_SUCCEEDED, DELETING_MARKETO_FORM_FAILED,
  UPDATING_MARKETO_FORM_REQUEST, UPDATING_PARDOT_FORM_REQUEST, UPDATING_MARKETO_FORM_SUCCEEDED, 
   
  CREATING_PARDOT_FORM_REQUEST, CREATING_PARDOT_FORM_SUCCEDDED, CREATING_PARDOT_FORM_FAILED,
  DELETING_PARDOT_FORM_REQUEST, DELETING_PARDOT_FORM_SUCCEEDED, DELETING_PARDOT_FORM_FAILED, 
  UPDATING_PARDOT_FORM_SUCCEEDED, UPDATING_MARKETO_FORM_FAILED, UPDATING_PARDOT_FORM_FAILED,

  CREATING_EXTERNAL_FORM_REQUEST, CREATING_EXTERNAL_FORM_SUCCEEDED, CREATING_EXTERNAL_FORM_FAILED,
  UPDATING_EXTERNAL_FORM_REQUEST, UPDATING_EXTERNAL_FORM_SUCCEEDED, UPDATING_EXTERNAL_FORM_FAILED,
  DELETING_EXTERNAL_FORM_REQUEST, DELETING_EXTERNAL_FORM_SUCCEEDED, DELETING_EXTERNAL_FORM_FAILED
} from 'constants/actionTypes';

import _ from 'lodash';

const initialState = {
  loading: false,
  fetched: false,
  invalidated: false,
  items: [],
  pagination: {
    currentPage: 0,
    totalPages: 0,
  },
  form: {},
  formManageView: false,
  errors: null,
  currentForm: null
};

const initialFormState = {
  loading: false,
  item: null,
  error: null
}

function formsReducer(state = initialState, action) {
  switch (action.type) {
    case CREATING_HUBSPOT_FORM_REQUEST:
    case CREATING_MARKETO_FORM_REQUEST:
    case CREATING_PARDOT_FORM_REQUEST:
    case CREATING_EXTERNAL_FORM_REQUEST: {
      return {
        ...state,
        loading: true
      }
    }

    case CREATING_HUBSPOT_FORM_SUCCEDDED:
    case CREATING_MARKETO_FORM_SUCCEDDED:
    case CREATING_PARDOT_FORM_SUCCEDDED:
    case CREATING_EXTERNAL_FORM_SUCCEEDED: {
      const response = action.payload;

      const id = response.id;
      const formState = state.form[response.id] || initialFormState;

      var forms = [action.payload, ...state.items];

      return {
        ...state,
        loading: false,
        items: forms,
        form: {
          ...state.form,
          [id]: {
            ...formState,
            item: response,
            loading: false,
          },
        },
        currentForm: response
      }
    }

    case CREATING_HUBSPOT_FORM_FAILED:
    case CREATING_MARKETO_FORM_FAILED:
    case CREATING_PARDOT_FORM_FAILED: 
    case CREATING_EXTERNAL_FORM_FAILED: {
      const error = action.payload;

      return {
        ...state,
        loading: false,
        error: error
      }
    }

    case UPDATING_HUBSPOT_FORM_REQUEST:
    case UPDATING_MARKETO_FORM_REQUEST:
    case UPDATING_PARDOT_FORM_REQUEST: {
      const { request } = action.payload;
      const formState = state.form[request.id] || initialFormState;

      return {
        ...state,
        form: {
          ...state.form,
          [request.id]: {
            ...formState,
            loading: true,
          },
        },
      }
    }

    case UPDATING_HUBSPOT_FORM_SUCCEEDED:
    case UPDATING_MARKETO_FORM_SUCCEEDED:
    case UPDATING_PARDOT_FORM_SUCCEEDED: {
      var form = action.payload;

      var items = state.items.filter(item => item.id !== form.id);
      items.unshift(form)

      const formState = state.form[form.id] || initialFormState;

      return {
        ...state,
        items: items,
        form: {
          ...state.form,
          [form.id]: {
            ...formState,
            item: form,
            loading: false,
          },
        },
        currentForm: form
      }
    }

    case UPDATING_HUBSPOT_FORM_FAILED:
    case UPDATING_MARKETO_FORM_FAILED:
    case UPDATING_PARDOT_FORM_FAILED: {
      const { formId, error } = action.payload;
      const formState = state.form[formId] || initialFormState;

      return {
        ...state,
        form: {
          ...state.form,
          [formId]: {
            ...formState,
            loading: false,
            error: error
          },
        },
      }
    }

    case FETCHING_CREATED_FORMS: {
      return {
        ...state,
        loading: true,
        invalidated: true
      }
    }

    case FETCHING_CREATED_FORMS_SUCCEEDED: {
      const { records, ...pagination } = action.payload;
      let items = [...state.items, ...records];
      items = _.uniqBy(items, 'id');

      return {
        ...state,
        loading: false,
        invalidated: false,
        items: items,
        pagination: pagination
      }
    }

    case FETCHING_CREATED_FORMS_FAILED: {
      var error = action.payload;

      return {
        ...state,
        loading: false,
        invalidated: false,
        error: error
      }
    }

    case FETCHING_FORM_REQUEST: {
      return {
        ...state,
        loading: true,
      }
    }

    case FETCHING_FORM_SUCCEEDED: {
      var { response } = action.payload;
      return {
        ...state,
        loading: false,
        currentForm: response
      }
    }

    case FETCHING_FORM_FAILED: {
      var { error } = action.payload;
      return {
        ...state,
        loading: false,
        error: error
      }
    }

    case FORM_MANAGE_VIEW: {
      var { isFormManageView } = action.payload;

      return {
        ...state,
        formManageView: isFormManageView
      }
    }

    case DELETING_HUBSPOT_FORM_REQUEST:
    case DELETING_MARKETO_FORM_REQUEST:
    case DELETING_PARDOT_FORM_REQUEST: {
      var { type } = action.payload;
      return state;
    }

    case DELETING_HUBSPOT_FORM_SUCCEEDED:
    case DELETING_MARKETO_FORM_SUCCEEDED:
    case DELETING_PARDOT_FORM_SUCCEEDED: {
      var { type, formId } = action.payload;

      var items = state.items;

      items = _.filter(items, function (item) {
        return item.id != formId
      })

      return {
        ...state,
        loading: false,
        items: items
      }
    }

    case DELETING_HUBSPOT_FORM_FAILED:
    case DELETING_MARKETO_FORM_FAILED:
    case DELETING_PARDOT_FORM_FAILED: {
      var { type, formId, error } = action.payload;

      return {
        ...state,
        loading: false,
        error: error
      }
    }

    case UPDATING_EXTERNAL_FORM_REQUEST: {
      const { id } = action.payload;
      const formState = state.form[id] || initialFormState;

      return {
        ...state,
        form: {
          ...state.form,
          [id]: {
            ...formState,
            updating: true,
          }
        }
      }
    }

    case UPDATING_EXTERNAL_FORM_SUCCEEDED: {
      const { id, response } = action.payload;

      var items = state.items.filter(item => item.id !== id);
      items.unshift(response)

      const formState = state.form[form.id] || initialFormState;

      return {
        ...state,
        items: items,
        form: {
          ...state.form,
          [form.id]: {
            ...formState,
            item: response,
            updating: false,
          },
        },
        currentForm: response
      }
    }

    case UPDATING_EXTERNAL_FORM_FAILED: {
      const { id, error } = action.payload;
      const formState = state.form[id] || initialFormState;

      return {
        ...state,
        form: {
          ...state.form,
          [id]: {
            ...formState,
            updating: false,
            error: error
          },
        },
      }
    }

    case DELETING_EXTERNAL_FORM_REQUEST: {
      const { id } = action.payload;
      const formState = state.form[id] || initialFormState;

      return {
        ...state,
        form: {
          ...state.form,
          [id]: {
            ...formState,
            deleting: true
          }
        }
      }
    }

    case DELETING_EXTERNAL_FORM_SUCCEEDED: {
      const { id } = action.payload;

      var items = state.items;

      items = _.filter(items, function (item) {
        return item.id != id
      })

      const form = _.omit(state.form, id);

      return {
        ...state,
        loading: false,
        items: items,
        form: form
      }
    }

    case DELETING_EXTERNAL_FORM_FAILED: {
      const { id, error } = action.payload;

      const formState = state.form[id] || initialFormState;

      return {
        ...state,
        form: {
          ...state.form,
          [id]: {
            ...formState,
            deleting: false,
            error: error
          }
        }
      }
    }

    case INVALIDATE_FORMS: {
      return {
        ...state,
        items: [],
        currentForm: null
      }
    }

    default:
      return state;
  }
}

export { formsReducer };